import styled from '@emotion/styled';

const SnackbarContainer = styled.div`
  position: fixed;
  bottom: 20px;
  right: 20px;
  background: #fff3cd;
  border: 1px solid #ffeaa7;
  color: #856404;
  padding: 16px 20px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  display: flex;
  align-items: center;
  gap: 12px;
  max-width: 380px;
  animation: slideIn 0.3s ease-out;

  @keyframes slideIn {
    from {
      transform: translateX(100%);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }
`;

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background: #ffc107;
  border-radius: 50%;
  font-weight: bold;
  font-size: 14px;
  color: #856404;
`;

const Message = styled.div`
  flex: 1;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.4;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  color: #856404;
  font-size: 18px;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: background-color 0.2s;
  opacity: 0.7;

  &:hover {
    background-color: rgba(133, 100, 4, 0.1);
    opacity: 1;
  }
`;

const DaysBadge = styled.span`
  background: #ffc107;
  color: #856404;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 700;
  margin: 0 4px;
`;

const TrialSnackbar = ({ daysLeft, onClose }) => {
  return (
    <SnackbarContainer>
      <IconContainer>!</IconContainer>
      <Message>
        You have <DaysBadge>{daysLeft} days</DaysBadge> left in your Free Trial
      </Message>
      <CloseButton onClick={onClose} aria-label="Close">
        ×
      </CloseButton>
    </SnackbarContainer>
  );
};

export default TrialSnackbar;